import React, { useCallback } from 'react'
import cx from 'classnames'
import { l, Icon } from '@manychat/manyui'

import { FIELD_LIST_MIN_WIDTH } from 'common/fields/constants'
import { TagsPicker } from 'common/tags/components/TagPicker/TagsPicker'

import styles from './TagHeader.module.css'

const TagHeader = ({ taggedWith, disabled, onSelect }) => {
  const handleSelect = useCallback(
    (event) => {
      const { value, name } = event.target
      onSelect(value, name)
    },
    [onSelect],
  )

  if (taggedWith) {
    return (
      <span className={cx('d-flex p-l', styles.taggedWith)}>
        <Icon.AddTag className="m-r-xxs m-l-xxs flex-shrink-0" size={18} />
        <span>{l.translate('Tagged with a <b>{taggedWith}</b>', { taggedWith })}</span>
      </span>
    )
  }

  return (
    <div style={{ width: FIELD_LIST_MIN_WIDTH }}>
      <TagsPicker
        onChange={handleSelect}
        disabled={disabled}
        placeholder={l.translate('Tag These Contacts')}
      />
    </div>
  )
}

export default TagHeader
